(() => {
  const page = document.querySelector('[data-oss-policy]');
  const header = document.querySelector('.oss-site-header');
  if (!page || !header) return;
  const updateOffset = () => {
    let container = header;
    let offset = 20;
    while (container && container !== document.body) {
      const position = getComputedStyle(container).position;
      if (position === 'fixed' || position === 'sticky') {
        offset += Math.ceil(container.getBoundingClientRect().height);
        break;
      }
      container = container.parentElement;
    }
    page.style.setProperty('--oss-policy-offset', `${offset}px`);
  };
  updateOffset();
  if ('ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
})();
